import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=82ad1f60&scoped=true&"
import script from "./MessageView.vue?vue&type=script&lang=js&"
export * from "./MessageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ad1f60",
  null
  
)

export default component.exports